import Decimal from 'decimal.js';

export const format = (value) => (value ? Decimal(value.toString().replace(/,/g, '')).toSignificantDigits().toNumber() : value);

/**
 * Format quantity for display - shows integer if whole number, decimal otherwise
 * e.g., 5.00 -> "5", 2.5 -> "2.5", 3.75 -> "3.75"
 */
export const formatQuantity = (value) => {
    if (value === null || value === undefined || value === '') {
        return '';
    }
    const num = Number(value);
    if (Number.isNaN(num)) {
        return value;
    }
    return Number.isInteger(num) ? num.toString() : num.toFixed(2).replace(/\.?0+$/, '');
};

Decimal.format = format;
Decimal.formatQuantity = formatQuantity;

export default Decimal;
